import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    alignItems: "center",
    marginLeft: "auto",
    "& > *": {
      margin: theme.spacing(1),
    },
  },
  primary: {
    color: "#fff",
    backgroundColor: theme.palette.primary.main,
  },
  subtitle: {
    color: "#000",
    marginTop: 1,
    fontSize: "14px",
    display: "none",
    [theme.breakpoints.up("md")]: {
      display: "block",
    }
  },
  buttonWrap: {
    margin: "5px",
    position: "relative",
  },
  drop: {
    padding: 0,
    margin: 0,
  },
  pos: {
    right: " calc(0px - 30px)",
    left: "inherit !important",
  },
}));

export default useStyles;
